module.exports = __webpack_public_path__ + "img/main-bn-02.5a147418.jpg";